import ApiClient from "./api-client";
import type { ChatMode, PreLessonValues, StudentSubmissionValues, TranscriptMessageValues } from "@live-writing/models";

class StudentService {
  public static async getPreLessonByCode(code: string): Promise<{ pre_lesson: PreLessonValues }> {
    const response = await ApiClient.get<{ pre_lesson: PreLessonValues }>(`/pre-lesson/code/${code}`);
    return response;
  }

  public static async createStudentSubmission(
    preLessonCode: string,
    firstName: string,
    lastNameInitial: string
  ): Promise<{ student_submission: StudentSubmissionValues; resumed: boolean }> {
    const response = await ApiClient.post<{ student_submission: StudentSubmissionValues; resumed: boolean }>(
      "/submission",
      {
        pre_lesson_code: preLessonCode,
        first_name: firstName,
        last_name_initial: lastNameInitial,
      }
    );
    return response;
  }

  public static async getStudentSubmission(id: number): Promise<{ student_submission: StudentSubmissionValues }> {
    const response = await ApiClient.get<{ student_submission: StudentSubmissionValues }>(`/submission/${id}`);
    return response;
  }

  public static async updateStudentSubmission(
    id: number,
    data: { transcript?: TranscriptMessageValues[]; time_spent_seconds?: number; opened_materials?: number[] }
  ): Promise<{ student_submission: StudentSubmissionValues }> {
    const response = await ApiClient.put<{ student_submission: StudentSubmissionValues }>(
      `/submission/${id}`,
      data
    );
    return response;
  }

  public static async sendChatMessage(
    submissionId: number,
    message: string,
    mode: ChatMode
  ): Promise<{ response: string; is_complete: boolean; student_submission: StudentSubmissionValues }> {
    const response = await ApiClient.post<{
      response: string;
      is_complete: boolean;
      student_submission: StudentSubmissionValues;
    }>(`/submission/chat/${submissionId}`, { message, mode });
    return response;
  }

  public static async completeSubmission(
    id: number
  ): Promise<{ student_submission: StudentSubmissionValues; already_completed: boolean }> {
    const response = await ApiClient.post<{
      student_submission: StudentSubmissionValues;
      already_completed: boolean;
    }>(`/submission/complete/${id}`, {});
    return response;
  }

  public static async startChatJob(
    submissionId: number,
    message: string,
    mode: ChatMode,
    previousResponseId?: string
  ): Promise<{ response_id: string; status: string }> {
    const response = await ApiClient.post<{ response_id: string; status: string }>(
      `/submission/chat-start/${submissionId}`,
      { message, mode, previous_response_id: previousResponseId }
    );
    return response;
  }

  public static async pollChatJob(
    responseId: string,
    mode: ChatMode,
    submissionId: number
  ): Promise<{
    status: string;
    response?: string;
    is_complete?: boolean;
    student_submission?: StudentSubmissionValues;
    error?: string;
  }> {
    const response = await ApiClient.get<{
      status: string;
      response?: string;
      is_complete?: boolean;
      student_submission?: StudentSubmissionValues;
      error?: string;
    }>(`/submission/chat-poll/${responseId}?mode=${mode}&submission_id=${submissionId}`);
    return response;
  }


}

export default StudentService;
